import React, { useEffect, useState } from 'react';
import { Outlet, useSearchParams } from 'react-router-dom';

import { PageLayoutContext } from '../../../interfaces';

export const PageLayoutComponent = React.memo(() => {
  const [searchParams] = useSearchParams();
  const [outletContext, setOutletContext] = useState<PageLayoutContext>();

  useEffect(() => {
    if (!outletContext) {
      const spName = searchParams.get('sp_name');
      const idpName = searchParams.get('idp_name');
      setOutletContext({
        encounteredProblem: searchParams.get('encounteredProblem') || undefined,
        errorCode: searchParams.get('error_code') || undefined,
        errorId: searchParams.get('error_id') || undefined,
        faq: searchParams.get('faq') || undefined,
        idpName: (idpName !== 'NC' && idpName) || undefined,
        platform: searchParams.get('platform') || undefined,
        spName: (spName !== 'NC' && spName) || undefined,
      });
    }
    // @NOTE only run once at mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    (outletContext && (
      <div className="fr-grid-row fr-grid-row--gutters fr-grid-row--center fr-mt-8w">
        <div className="fr-col-xl-5 fr-col-lg-7 fr-col-md-10 fr-col-sm-10 fr-px-2w">
          <Outlet context={outletContext} />
        </div>
      </div>
    )) ||
    null
  );
});

PageLayoutComponent.displayName = 'PageLayoutComponent';
